<div class="market-footer">
  <p
    *ngIf="!isOutOfOperationTime && timeLeftMarket"
    class="market-hours market-hours--open"
  >
    <span
      class="market-flag"
      [tourAnchor]="anchorId"
      [attr.data-tour-anchor]="anchorId"
    ></span>
    El
    <span
      class="market-tooltip"
      (mouseenter)="showTooltipMarket = true"
      (mouseleave)="showTooltipMarket = false"
      >Mercado<hb-tooltip-component
        *ngIf="showTooltipMarket && tooltipMarketText"
        [text]="tooltipMarketText"
        [relativePosition]="'top'"
        [isLarge]="true"
      >
      </hb-tooltip-component
    ></span>
    cierra en {{ timeLeftMarket.hours }} horas y
    {{ timeLeftMarket.minutes }} minutos
  </p>
  <ng-container *ngIf="isOutOfOperationTime">
    <p
      *ngIf="!isOutOfOperationTimeMoreOneDay"
      class="market-hours market-hours--close"
    >
      <span
        class="market-flag"
        [tourAnchor]="anchorId"
        [attr.data-tour-anchor]="anchorId"
      ></span
      ><span
        class="market-tooltip"
        (mouseenter)="showTooltipMarket = true"
        (mouseleave)="showTooltipMarket = false"
        >Mercado<hb-tooltip-component
          *ngIf="showTooltipMarket && tooltipMarketText"
          [text]="tooltipMarketText"
          [relativePosition]="'top'"
          [isLarge]="true"
        >
        </hb-tooltip-component
      ></span>
      cerrado
    </p>
    <p
      *ngIf="isOutOfOperationTimeMoreOneDay"
      class="market-hours market-hours--close market-hours--close--more"
    >
      <span class="market-flag"></span> El
      <span
        class="market-tooltip"
        (mouseenter)="showTooltipMarket = true"
        (mouseleave)="showTooltipMarket = false"
        >Mercado<hb-tooltip-component
          *ngIf="showTooltipMarket && tooltipMarketText"
          [text]="tooltipMarketText"
          [relativePosition]="'top'"
          [isLarge]="true"
        >
        </hb-tooltip-component
      ></span>
      abre el {{ marketConfiguration.nextWorkingDate | date: 'longDate' }}
    </p>
  </ng-container>
</div>
